export default __webpack_public_path__ + "static/manzo-998d2765d2309f27fcae0170d4f89adc.png";